import * as React from 'react';
import canUseDom from '../Dom/canUseDom';
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useLayoutEffect = process.env.NODE_ENV !== 'test' && canUseDom() ? React.useLayoutEffect : React.useEffect;
export default useLayoutEffect;
export var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  var firstMountRef = React.useRef(true);
  useLayoutEffect(function () {
    if (!firstMountRef.current) {
      return callback();
    }
  }, deps);
  // We tell react that first mount has passed
  useLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-virtual-list/node_modules/rc-util/es/hooks/useLayoutEffect.js
// module id = 272
// module chunks = 0